import React, { useState, useEffect } from 'react';
import { Form, Button, Checkbox, Input, Select, Icon } from 'semantic-ui-react';
import ReactGA from 'react-ga4';

import { STATES } from '~/utils';

interface FilterProps {
  onFilterChange: (filters: any) => void;
  triggerReset: boolean;
}

const maturityOptions = [
  { key: 'ppa_bid', text: 'PPA Rate Bid', value: 'PPA Rate Bid' },
  { key: 'dev_sale', text: 'Dev Sale', value: 'Dev Sale' },
  { key: 'ntp_sale', text: 'NTP Sale', value: 'NTP Sale' },
  { key: 'cod_sale', text: 'MC Sale', value: 'MC Sale' },
  { key: 'operating', text: 'Operating Sale', value: 'Operating Sale' },
];

const projectTypeOptions = [
  { key: 'ci', text: 'Commercial and Industrial', value: 'CI' },
  { key: 'csg', text: 'Community Solar', value: 'COMMUNITY_SOLAR' },
  { key: 'utility', text: 'Utility', value: 'UTILITY' },
];

const MarketplaceFilters: React.FC<FilterProps> = ({ onFilterChange, triggerReset }) => {
  const [filters, setFilters] = useState({
    maturity: '',
    state: '',
    projectType: '',
    sizeRange: [0, 100],
    hasStorage: false,
  });

  useEffect(() => {
    if (triggerReset) {
      handleReset();
    }
  }, [triggerReset]);

  const handleChange = (e: React.ChangeEvent<any>, { name, value, type, checked }: any) => {
    setFilters((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSizeChange = (e: React.ChangeEvent<HTMLInputElement>, { name, value }: any) => {
    setFilters((prev) => ({
      ...prev,
      sizeRange: name === 'minSize'
        ? [Number(value), prev.sizeRange[1]]
        : [prev.sizeRange[0], Number(value)],
    }));
  };

  const applyFilters = () => {
    onFilterChange(filters);
    ReactGA.event({
      category: 'Marketplace',
      action: 'Apply listing filters',
      label: JSON.stringify(filters),
    });
  };

  const handleReset = () => {
    setFilters({
      maturity: '',
      state: '',
      projectType: '',
      sizeRange: [0, 100],
      hasStorage: false,
    });
    onFilterChange({
      maturity: '',
      state: '',
      projectType: '',
      sizeRange: [0, 100],
      hasStorage: false,
    });
  };


  return (
    <Form className="marketplace-filters">
      <Icon
        name="close"
        link
        floated="right"
        style={{ marginTop: '0.5em', marginRight: '0.5em', cursor: 'pointer', position: 'absolute', right: '0px', top: '-4px' }}
        onClick={applyFilters}
      />
      <h2>Listing Filters</h2>
      <Form.Field>
        <label>Development stage</label>
        <Select
          placeholder="Select a deal stage..."
          options={maturityOptions}
          name="maturity"
          value={filters.maturity}
          onChange={(_, data) => handleChange(_, data)}
          selectOnBlur={false}
          clearable
        />
      </Form.Field>
      <Form.Field>
        <label>State</label>
        <Select
          placeholder="Choose a state..."
          options={STATES}
          name="state"
          value={filters.state}
          onChange={handleChange}
          selectOnBlur={false}
          clearable
        />
      </Form.Field>
      <Form.Field>
        <label>Project Type</label>
        <Select
          placeholder="Select a project type..."
          options={projectTypeOptions}
          name="projectType"
          value={filters.projectType}
          onChange={handleChange}
          selectOnBlur={false}
          clearable
        />
      </Form.Field>
      <Form.Group widths="equal" stackable style={{ marginBottom: '2em' }}>
        <Form.Field>
          <label>Min PV size (MWdc)</label>
          <Input
            type="number"
            placeholder="Min PV size (MWdc)"
            name="minSize"
            value={filters.sizeRange[0]}
            onChange={handleSizeChange}
            min="0"
          />
        </Form.Field>
        <Form.Field>
          <label>Max PV size (MWdc)</label>
          <Input
            type="number"
            placeholder="Max PV size (MWdc)"
            name="maxSize"
            value={filters.sizeRange[1]}
            onChange={handleSizeChange}
            min="0"
          />
        </Form.Field>
      </Form.Group>
      <Form.Field style={{ marginBottom: '2em' }}>
        <Checkbox
          toggle
          label="Has Storage"
          name="hasStorage"
          checked={filters.hasStorage}
          onChange={(_, data) => handleChange(_, data)}
        />
      </Form.Field>
      <Button primary onClick={applyFilters} style={{ marginRight: '8px' }}>
        Apply Filters
      </Button>
      <Button outlined onClick={handleReset}>
        Reset Filters
      </Button>
    </Form>
  );
};

export default MarketplaceFilters;